var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReminderIconSolidY(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7744 12.4928L14.3746 12.6195L18.3471 14.6462C19.014 14.8703 19.4522 15.5426 19.395 16.2636V16.5169L18.5376 22.48C18.4805 22.899 18.2995 23.2887 17.966 23.5615C17.6707 23.8538 17.2801 24 16.8705 24H10.3163C9.84947 24 9.42078 23.8246 9.1064 23.4836L3.40002 17.6667L4.25741 16.6923C4.48605 16.4487 4.84805 16.3123 5.19101 16.3318H5.46728L9.2493 17.1795V6.94872C9.2493 6.43189 9.45004 5.93622 9.80735 5.57077C10.1647 5.20531 10.6493 5 11.1546 5C11.6599 5 12.1445 5.20531 12.5019 5.57077C12.8592 5.93622 13.0599 6.43189 13.0599 6.94872V12.4928H13.7744Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30061 1.08253C10.555 0.972489 11.8449 0.972489 13.0993 1.08253M16.798 1.7708C17.8599 2.09391 18.773 2.50633 19.4871 2.98539M21.0165 4.64533C21.2611 5.20983 21.2611 5.79026 21.0165 6.35475M19.4871 8.01919C18.7691 8.49705 17.8526 8.90795 16.788 9.22929M13.0993 9.91755C11.8448 10.0275 10.5551 10.0275 9.30061 9.91755M5.60189 9.22929C4.53999 8.90618 3.62689 8.49375 2.91282 8.01469M1.38335 6.35475C1.13882 5.79026 1.13882 5.20983 1.38335 4.64533M2.91282 2.98089C3.63083 2.50303 4.54733 2.09213 5.61189 1.7708",
    stroke: "#FFC107",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminderIconSolidY);
export default __webpack_public_path__ + "static/media/reminder_icon_solid_y.5539a1a18c50db48f27976b93aa8c24a.svg";
export { ForwardRef as ReactComponent };